// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zbponitofdhxisnyhnfd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpicG9uaXRvZmRoeGlzbnlobmZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIwNDk5MTQsImV4cCI6MjA1NzYyNTkxNH0.Fndqg98ar6tF5wz1DUxNB3nfVTnLkPNmSqM4eWFkmwo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);